import request from '@/utils/request'
// import qs from 'qs'

//查看Gps车辆的实时数据
export const getGpsr = (getData) => {
  return request({
    url: '/checkscreen/getGpsr',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 检测检查的 地址
export const getCheckInspect = (getData) => {
  return request({
    url: '/checkscreen/getCheckInspect',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 根据省 查看省下所有市的数量
export const getCheckInspectCity = (data) => {
  return request({
    url: '/checkscreen/getCheckInspectCity',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  })
}
// 省市下经纬度
export const getlatlon = (data) => {
  return request({
    url: '/checkscreen/getlatlon',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  })
}
// 检测的 点位详细信息
export const getCheckApllyInfoByApplyId = (getData) => {
  return request({
    url: '/check/getApllyInfoByApplyId',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 检查的 点位详细信息
export const getInspectApllyInfoByApplyId = (getData) => {
  return request({
    url: '/inspect/getApllyInfoByApplyId',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
